<template>
	<div class="no-content-panel">
		<div class="no-content-panel-icon" :style="iconStyle">
			<t-timpex-icon :icon="icon" :type="iconType" size="xl"/>
		</div>
		<div class="no-content-panel-text" :style="textStyle">
			{{text}}
		</div>
	</div>
</template>

<script>
export default {
	name: 'TNoContentPanel',
	props: {
		icon: String,
		iconType: String,
		text: String,
		noBetweenGap: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		iconStyle() {
			return this.noBetweenGap ? {} : { 'margin-bottom': '15px' };
		},
		textStyle() {
			return this.noBetweenGap ? {} : { 'margin-top': '15px' };
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.no-content-panel{
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	background-color: get-color($background, 'tint2');
}
.no-content-panel-icon{
	display: flex;
	align-items: center;
	justify-content: center;
	height: 80px;
	width: 80px;
	border-radius: 100%;
	color: get-color($icon, 'muted');
	background-color: get-color($background, 'tint3');
}
.no-content-panel-text{
	@extend %font-families-ui;
	@extend %text-medium;
	user-select: none;
	font-weight: 500;
	max-width: 390px;
	text-align: center;
	color: get-color($text, 'muted');
	padding: 0px 15px;
}
</style>

<docs>
```jsx
<div style="height: 300px;">
<t-no-content-panel icon="order" text="No orders found."/>
</div>
```
</docs>